import React, {Component} from 'react';
import {TextArea} from 'semantic-ui-react';

class TextAreaField extends Component {
  render() {
    const {input, disabled, required, meta, invalidMessage = 'Por favor, llene este campo', ...custom} = this.props;
    return (
      <TextArea
        {...input}
        {...custom}
        disabled={disabled}
        required={required}
        style={!input.value && !disabled && required ? {'borderColor': 'red', 'backgroundColor': '#fff5f6'} : null}
        onInvalid={this.setError.bind(this, invalidMessage)}
        onInput={this.setError.bind(this, '')}
      />
    );
  }

  setError(message, event) {
    event.stopPropagation();
    event.target.setCustomValidity(message);
  }
}

export default TextAreaField;
